import React from 'react';
import ReactDOM from 'react-dom/client';

import r1 from "./Referable/EyePACS-DEV-RG-1.jpg";
import r2 from "./Referable/EyePACS-DEV-RG-10.jpg";
import r3 from "./Referable/EyePACS-DEV-RG-100.jpg";
import r4 from "./Referable/EyePACS-DEV-RG-1000.jpg";
import r5 from "./Referable/EyePACS-DEV-RG-1001.jpg";
import r6 from "./Referable/EyePACS-DEV-RG-1002.jpg";
import r7 from "./Referable/EyePACS-DEV-RG-1003.jpg";
import r8 from "./Referable/EyePACS-DEV-RG-1004.jpg";
import r9 from "./Referable/EyePACS-DEV-RG-1005.jpg";
import nr1 from "./Non Referable/EyePACS-DEV-NRG-1.jpg";
import nr2 from "./Non Referable/EyePACS-DEV-NRG-10.jpg";
import nr3 from "./Non Referable/EyePACS-DEV-NRG-100.jpg";
import nr4 from "./Non Referable/EyePACS-DEV-NRG-1000.jpg";
import nr5 from "./Non Referable/EyePACS-DEV-NRG-1001.jpg";
import nr6 from "./Non Referable/EyePACS-DEV-NRG-1002.jpg";
import nr7 from "./Non Referable/EyePACS-DEV-NRG-1003.jpg";
import nr8 from "./Non Referable/EyePACS-DEV-NRG-1004.jpg";
import nr9 from "./Non Referable/EyePACS-DEV-NRG-1005.jpg";

const referable = [r1,r2,r3,r4,r5,r6,r7,r8,r9];
const nonReferable = [nr1,nr2,nr3,nr4,nr5,nr6,nr7,nr8,nr9];

function Parse(){
    return <div></div>;
}
export default Parse;
export {referable,nonReferable};